<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-xs-8">
          <h1 id="proy-code" class="pull-left">Reportes & Media</h1>
        </div>
        <div class="col-xs-4">
          <button class="btn btn-app pull-right bg-red" v-if="puedoEditar()" @click="crear()">
            <i class="fa fa-plus"></i> Nuevo
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4 form-group">
          <select v-model="filtros.tipo_reporte" class="form-control"  @change="filtrarDatos(1)">
            <option :value="null">Todos los tipos</option>
            <option :value="'media'">Media</option>
            <option :value="'reporte'">Reporte</option>
          </select>
        </div>
        <!--div class="col-md-6 form-group">
          <div class="input-group">
            <input type="text" name="search" v-model="filtros.buscar" class="form-control" placeholder="Buscar..." :disabled="!$store.state.online">
            <div class="input-group-btn">
              <button type="button" class="btn btn-default" @click="filtrarDatos(1)" :disabled="!$store.state.online">
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div-->
      </div>

      <div class="row">
          <div class="col-md-12 tab-container">
              <div class="nav-tabs-custom">
                  <ul class="nav nav-tabs pull-left">
                    <li class="active"><a href="#reportes" data-toggle="tab" aria-expanded="true" @click="cambiarSolapa('reportes')">Reportes</a></li>
                    <li class=""><a href="#archivo" data-toggle="tab" aria-expanded="false" @click="cambiarSolapa('archivo')">Archivo</a></li>
                  </ul>
                  <div class="tab-content">
                      <div class="tab-pane active" id="reportes">
                        <div class="clearfix"></div>
                        <tabla-reporte-media v-if="tabla_reportes.mostrar" :solapa="'reportes'" :data="reportes" :total="tabla_reportes.total" :regPagina="filtros._limit" :paginaActual="tabla_reportes.pagina" @rm:filtar="filtrarDatos" @rm:acciones="acciones" :puedoEditar="puedoEditar()" :cargando="tabla_reportes.cargando"></tabla-reporte-media>
                      </div>
                      <div class="tab-pane" id="archivo">
                        <div class="clearfix"></div>
                        <tabla-reporte-media v-if="tabla_archivo.mostrar" :solapa="'archivo'" :data="archivados" :total="tabla_archivo.total" :regPagina="filtros._limit" :paginaActual="tabla_archivo.pagina" @rm:filtar="filtrarDatos" @rm:acciones="acciones" :puedoEditar="puedoEditar()" :cargando="tabla_archivo.cargando"></tabla-reporte-media>
                      </div>
                      <!-- /.tab-pane -->
                    </div>
                </div>
                <!-- /.tab-content -->
            </div>        
      </div>
    </div>
    <a-m-reporte-media :mostrar="vistaAM.mostrar" :item="vistaAM.item" :editar="vistaAM.accion !== 'ver'" @am-rm:cerrar="onCerrarVistaAM"></a-m-reporte-media>
    </div>
  </div>
</template>
<script>
import api from '../../../api'
import {toQueryString} from '../../../filters/object'
import AMReporteMedia from './AMReporteMedia'
import TablaReporteMedia from './TablaReporteMedia'
import moment from 'moment'
import db from '../../../core/pouchdb'
import _ from 'lodash'
import { EventBus } from '../../../core/event-bus.js'

require('moment/locale/es')
export default {
  name: 'ReportesMedia',
  components: {
    AMReporteMedia,
    TablaReporteMedia
  },
  filters: {
    toQueryString
  },
  props: {
    codigo_proyecto: {
      type: String,
      default () {
        return null
      }
    }
  },
  data () {
    return {
      vistaAM: {
        mostrar: false,
        item: null,
        accion: 'crear'
      },
      tabla_reportes: {
        data: [],
        total: 0,
        pagina: 1,
        mostrar: true,
        index_item_actual: -1,
        cargando: true
      },
      tabla_archivo: {
        data: [],
        total: 0,
        pagina: 1,
        mostrar: false,
        index_item_actual: -1,
        cargando: false
      },
      solapaActual: 'reportes',
      filtros: {
        codigo_proyecto: this.codigo_proyecto,
        tipo_reporte: null,
        _sort: 'fecha:desc',
        _limit: 50,
        buscar: ''
      },
      errores: null,
      loading: true,
      rolesEditar: ['root', 'manager', 'jefe_de_obras', 'coordinador']
    }
  },
  computed: {
    archivados: function () {
      let _filtros = { archivado: true }

      if (this.filtros.tipo_reporte) {
        _filtros.tipo_reporte = this.filtros.tipo_reporte
      }

      return _.orderBy(_.filter(this.tabla_archivo.data, _filtros), 'fecha', 'desc')
    },
    reportes: function () {
      let _filtros = { archivado: false }

      if (this.filtros.tipo_reporte) {
        _filtros.tipo_reporte = this.filtros.tipo_reporte
      }
      return _.orderBy(_.filter(this.tabla_reportes.data, _filtros), 'fecha', 'desc')
    }
  },
  mounted () {
    let vm = this

    EventBus.$on('sync-completed', () => {
      vm.filtrarDatos(1)
    })

    vm.tabla_reportes.mostrar = true
    vm.tabla_archivo.mostrar = true
    vm.getListado(this.solapaActual)
  },
  destroyed () {
    EventBus.$off('sync-completed')
  },
  methods: {
    filtrarDatos (pagina, solapa) {
      let vm = this
      let _solapa = solapa || this.solapaActual

      if (solapa) {
        vm['tabla_' + solapa].pagina = pagina
      } else {
        vm.tabla_reportes.pagina = pagina
        vm.tabla_archivo.pagina = pagina
      }

      vm.getListado(_solapa)
    },
    getListado (solapa) {
      let vm = this
      let filtrosBuscar = {}

      if (vm.filtros.buscar) {
        filtrosBuscar.nombre_proyecto_contains = vm.filtros.buscar
        filtrosBuscar.cliente_empresa_contains = vm.filtros.buscar
      }

      if (solapa === 'archivo') {
        filtrosBuscar.archivado = true
      } else {
        filtrosBuscar.archivado = false
      }

      filtrosBuscar._start = (vm['tabla_' + solapa].pagina - 1) * this.filtros._limit

      let _filtros = _.assign({}, vm.filtros, filtrosBuscar)
      delete _filtros.buscar

      vm['tabla_' + solapa].cargando = true
      api.getReportes(this.$options.filters.toQueryString(_filtros)).then(resp => {
        vm.dataActualizada(resp.data, solapa).then(data => {
          vm['tabla_' + solapa].data = data
          vm['tabla_' + solapa].total = resp.total
          vm['tabla_' + solapa].cargando = false
        })
      }, error => {
        vm.dataActualizada([], solapa).then(data => {
          vm['tabla_' + solapa].data = data
          vm['tabla_' + solapa].total = data.length
          vm['tabla_' + solapa].cargando = false
        })
        vm.errores = error.message
      })
    },
    dataActualizada (data, solapa) {
      let vm = this
      let _pagina = vm['tabla_' + solapa].pagina

      if (!this.$store.state.online) {
        return vm.combinarDataApiLocalID(data).then((resData) => {
          if (solapa === 'reportes') {
            if (_pagina === 1) {
              return db.findByFilters('reporte_media', {action: 'create', codigo_proyecto: vm.codigo_proyecto}).then(dbData => {
                return _.unionBy(dbData.docs, resData)
              })
            }
          } else {
            if (_pagina === 1) {
              return db.findByFilters('reporte_media', {archivado: true, codigo_proyecto: vm.codigo_proyecto}).then(dbData => {
                return _.unionBy(dbData.docs, resData)
              })
            }
          }
          return Promise.resolve(resData)
        })
      } else {
        return Promise.resolve(data)
      }
    },
    combinarDataApiLocalID (dataApi) {
      let _ids = []
      for (let i = 0; i < dataApi.length; i++) {
        _ids.push(dataApi[i].id)
      }
      if (_ids.length > 0) {
        return db.findByIds(_ids, 'reporte_media').then(dbData => {
          return _.unionBy(dbData.docs, dataApi, 'id')
        })
      } else {
        return Promise.resolve(dataApi)
      }
    },
    cambiarSolapa (solapa) {
      this.solapaActual = solapa
      this.getListado(solapa)
    },
    puedoEditar () {
      return this.rolesEditar.indexOf(this.$store.state.user.role.type) > -1
    },
    crear () {
      this.vistaAM.item = _.assign({
        codigo_proyecto: this.codigo_proyecto,
        tipo_reporte: null,
        usuario: this.$store.state.user.username,
        fecha: moment().format('YYYY-MM-DD') + 'T00:00:00.000',
        archivado: false,
        media: []
      })
      this.vistaAM.accion = 'crear'
      this.vistaAM.mostrar = true
    },
    editar (item, index) {
      this['tabla_' + this.solapaActual].index_item_actual = index
      this.vistaAM.item = _.cloneDeep(item)
      this.vistaAM.item.fecha = this.vistaAM.item.fecha.replace('Z', '')
      this.vistaAM.accion = 'editar'
      this.vistaAM.mostrar = true
    },
    ver (item) {
      this.vistaAM.item = _.cloneDeep(item)
      this.vistaAM.item.fecha = this.vistaAM.item.fecha.replace('Z', '')
      this.vistaAM.accion = 'ver'
      this.vistaAM.mostrar = true
    },
    onCerrarVistaAM (data) {
      let vm = this
      this.vistaAM.mostrar = false
      if (data) {
        this.$store.commit('SHOW_SUCCESS_ALERT', {
          message: 'La operación finalizó con éxito'
        })

        if (vm.vistaAM.accion === 'editar') {
          let _index = vm['tabla_' + vm.solapaActual].index_item_actual
          vm.$set(vm['tabla_' + vm.solapaActual].data, _index, data)
        } else {
          vm.filtrarDatos(1, vm.solapaActual)
        }

        vm['tabla_' + vm.solapaActual].index_item_actual = -1
      }
    },
    archivar (item, value) {
      let vm = this
      let tabla = value ? 'reportes' : 'archivo'

      vm['tabla_' + tabla].cargando = true
      item.archivado = value
      vm.archivando = true
      if (vm.$store.state.online) {
        api.saveReportes(item).then(data => {
          vm.archivando = false
          vm['tabla_' + tabla].cargando = false
          vm.getListado(this.solapaActual)
        }, error => {
          vm.archivando = false
          vm['tabla_' + tabla].cargando = false
          vm.errores = error.message
        })
      } else {
        if (value) {
          db.save(item, 'reporte_media', 'edit').then(function (response) {
            item._rev = response.rev
            vm['tabla_' + tabla].cargando = false
            vm.archivando = false
            // vm.getListado(vm.solapaActual)
          }).catch(function (error) {
            vm.archivando = false
            vm['tabla_' + tabla].cargando = false
            vm.errores = error.message
          })
        } else {
          vm['tabla_' + tabla].cargando = false
          alert('Para desarchivar el registro, debe estar online')
        }
      }
    },
    acciones (accion, item, index) {
      let vm = this
      switch (accion) {
        case 'ver':
          vm.ver(item)
          break
        case 'editar':
          vm.editar(item, index)
          break
        case 'archivar':
          vm.archivar(item, true)
          break
        case 'desarchivar':
          vm.archivar(item, false)
          break
      }
    }
  }
}
</script>
<style scoped>
  h1#proy-code {
    margin-top: 0;
  }
  .tab-container{
    padding-top: 20px
  }
</style>


// WEBPACK FOOTER //
// src/components/views/reportes-media/index.vue